if (!customElements.get('testimonials-component')) {
  class Testimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.testimonials__items',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.enableMobileSlider = this.dataset.enableMobileSlider === 'true';
      this.items = parseInt(this.dataset.items, 10) || 1;
      this.itemsMobile = parseInt(this.dataset.itemsMobile, 10) || 1;
      this.tabletItems = parseInt(this.dataset.tabletItems, 10) || this.itemsMobile;
      this.tabletLargeItems = parseInt(this.dataset.tabletLargeItems, 10) || this.tabletItems;

      this.sliderInstance = false;

      this.boundInit = this.init.bind(this);
      this.onQuoteClick = this.onQuoteClick.bind(this);
      this.onQuoteKeydown = this.onQuoteKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.onQuoteClick);
      this.addEventListener('keydown', this.onQuoteKeydown);

      if (this.enableSlider) {
        document.addEventListener('matchMobile', this.boundInit);
        document.addEventListener('unmatchMobile', this.boundInit);
        if (typeof Shopify !== 'undefined' && Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
        this.init();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('matchMobile', this.boundInit);
      document.removeEventListener('unmatchMobile', this.boundInit);
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      this.removeEventListener('click', this.onQuoteClick);
      this.removeEventListener('keydown', this.onQuoteKeydown);
      this.destroySlider();
    }

    onBlockSelect(e) {
      if (String(e.detail.sectionId) !== String(this.sectionId)) return;
      if (!this.sliderInstance || !this.sliderInstance.slider) return;
      const { target } = e;
      const index = Number(target.dataset.index);
      if (Number.isNaN(index)) return;
      this.sliderInstance.slider.slideToLoop(index);
    }

    isMobileViewport() {
      const mqString =
        (FoxTheme.config && FoxTheme.config.mediaQueryMobile) || 'screen and (max-width: 767px)';
      try {
        return window.matchMedia(mqString).matches;
      } catch (err) {
        return Boolean(FoxTheme.config && FoxTheme.config.mqlMobile);
      }
    }

    onQuoteClick(event) {
      if (event.target.closest('a')) return;
      const hit = event.target.closest('[data-testimonial-quote]');
      if (!hit || !this.contains(hit)) return;
      this.toggleQuoteExpand(hit);
    }

    onQuoteKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const hit = event.target.closest('[data-testimonial-quote]');
      if (!hit || !this.contains(hit)) return;
      event.preventDefault();
      this.toggleQuoteExpand(hit);
    }

    toggleQuoteExpand(hit) {
      const inner = hit.querySelector('.testimonial__content');
      if (!inner) return;
      const expanded = inner.classList.toggle('testimonial__content--expanded');
      hit.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    init() {
      if (!this.enableSlider) return;
      const mobile = this.isMobileViewport();
      if (mobile && !this.enableMobileSlider) {
        this.destroySlider();
        return;
      }
      if (!this.sliderInstance) {
        this.initSlider();
      }
    }

    initSlider() {
      if (this.sliderInstance || !this.sliderWrapper) return;

      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);
      const slidesMobile = this.itemsMobile > 0 ? this.itemsMobile : 1;

      const prevEl = this.section ? this.section.querySelector(this.selectors.prevEl) : null;
      const nextEl = this.section ? this.section.querySelector(this.selectors.nextEl) : null;

      const sliderOptions = {
        slidesPerView: slidesMobile,
        spaceBetween: columnGap.mobile,
        pagination: false,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems,
            spaceBetween: columnGap.tablet,
          },
          1024: {
            slidesPerView: this.tabletLargeItems,
            spaceBetween: columnGap.tabletLarge,
          },
          1280: {
            slidesPerView: this.items,
            spaceBetween: columnGap.desktop,
          },
        },
        loop: true,
        threshold: 2,
      };

      if (prevEl && nextEl) {
        sliderOptions.navigation = { nextEl, prevEl };
      } else {
        sliderOptions.navigation = false;
      }

      this.classList.add(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.grid);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);
      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();

      const focusableElements = FoxTheme.a11y.getFocusableElements(this);
      focusableElements.forEach((element) => {
        element.addEventListener('focusin', () => {
          const slide = element.closest('.swiper-slide');
          this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
        });
      });
    }

    destroySlider() {
      if (!this.sliderWrapper) return;
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (this.sliderInstance) {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('testimonials-component', Testimonials);
}
